import { NewS3File } from "@app/usecases/FileUseCases";
import { S3FileFromBulkUpload } from "@app/usecases/VersionUseCases";
import { atom } from "jotai";

export const newS3FilesAtom = atom<NewS3File[]>([]);
export const bulkUploadInputsAtom = atom<S3FileFromBulkUpload[]>([]);
